import irelandApi from '../irelandApi';

export const getArticle = (id) => (dispatch) => {
    dispatch({type: 'GET_ARTICLE_PENDING', payload: []});
  
    return irelandApi.get(`/api/articles/${id}`)
                     .then(function (response) {
                       dispatch({type: 'GET_ARTICLE_FULFILLED', payLoad: response.data});
                     })
                     .catch(function (error) {
                       dispatch({type: 'GET_ARTICLE_REJECTED', payLoad: error});
                     });
  };


// WEBPACK FOOTER //
// ./src/actions/article.js